import { Component, ElementRef, ViewChild } from "@angular/core";
import { IonicPage, NavController, NavParams, ViewController } from "ionic-angular";
import { UtilProvider } from "../../../providers/util/util";
import { SendTaskProvider } from "../../../providers/send-task/send-task";
import { QrCodeProvider } from "../../../providers/qr-code/qr-code";
import { CustomLoadingProvider } from "../../../providers/custom-loading/custom-loading";
import { MyAlertProvider } from "../../../providers/my-alert/my-alert";
import { PermanentQr } from "../permanent-qr";
import { ScrollListComponent } from "../../../components/scroll-list/scroll-list";
import { PermanentQrHomePage } from "../permanent-qr-home/permanent-qr-home";
import { global } from "../../../environments/global";
import { Bot } from "../../../class/user";

/**
 * Generated class for the PermanentQrEditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  defaultHistory: ["PermanentQrHomePage"]
})
@Component({
  selector: "page-permanent-qr-edit",
  templateUrl: "permanent-qr-edit.html"
})
export class PermanentQrEditPage {

  // @ViewChild("test") test: ElementRef;
  @ViewChild("thumbUrl") thumbUrl;
  is_upload_logo;
  logo_error;
  pqr: PermanentQr;

  isFormDirty: boolean = false;
  clientInfo;

  singleChatroomData = {
    chatroom_list: []
  };

  multiChatroomData: Array<any> = [{
    classification: "",
    chatroom_list: []
  }];

  disabledChatrooms: Array<any> = [];
  memberCountLimit: number;
  customQrcode;
  customQrname: string;


  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public util: UtilProvider,
              public sendTaskService: SendTaskProvider,
              public qrCodeService: QrCodeProvider,
              public csLoader: CustomLoadingProvider,
              public myAlert: MyAlertProvider,
              private viewCtrl: ViewController) {

    this.pqr = this.navParams.get("pqr");
  }

  ionViewDidLoad() {
    if (this.pqr.acquisition_id) {
      this.getPqrDetail();
    }
    this.getDisabledChatrooms();
    this.getBasicInfo();
  }

  getPqrDetail() {
    this.csLoader.showLoader();

    this.qrCodeService.getEventDetail(this.pqr.acquisition_id).subscribe(res => {
      this.csLoader.dismissLoader();

      this.pqr = res["content"];
      this.memberCountLimit = this.pqr["member_count_limit"];
      if (!this.pqr.classify_switch) {
        this.singleChatroomData.chatroom_list = this.pqr.chatroom_info_list || [];
        this.singleChatroomData.chatroom_list
          .forEach(item => item.chatroom_nickname = (item.nickname || item.nickname_default));
      } else {
        this.multiChatroomData = this.pqr.chatroom_info_list || [];
        this.multiChatroomData.forEach(value => {
          value.chatrooms.forEach(item => {
            item.chatroom_nickname = (item.nickname || item.nickname_default);
          });
          value.chatroom_list = value.chatrooms;
        });
      }

    }, err => {
      this.csLoader.dismissLoader();
    });
  }

  getBasicInfo() {
    this.util.getBasicInfo().subscribe(res => {
      this.clientInfo = res["client_info"];
    });
  }

  getDisabledChatrooms() {
    this.qrCodeService.getDisabledChatrooms(this.pqr.acquisition_id).subscribe(res => {
      this.disabledChatrooms = res["content"]["disabled_chatroom_list"];
    });
  }

  addNewGroup() {
    this.multiChatroomData.push({
      classification: "",
      chatroom_list: []
    });
  }

  deleteGroup(index) {
    this.multiChatroomData.splice(index, 1);
  }

//切换toggle的时候输入框blur，不然会弹出小键盘
  mustBlur() {
    let inputs = document.getElementsByTagName("input");
    let textareas = document.getElementsByTagName("textarea");
    Array.from(inputs).forEach((item)=>{item.blur()});
    Array.from(textareas).forEach((item)=>{item.blur()});
  }

  /**
   * 获取分类模式下正确的disabled 群列表*/
  getMultiDisabledChatrooms(item) {
    let result = this.disabledChatrooms;
    this.multiChatroomData.forEach(classify => {
      if (item.classification != classify.classification) result = result.concat(classify.chatroom_list);
    });
    return result;
  }

  changeMember() {
    if (!this.memberCountLimit) {
      this.memberCountLimit = maxLimit;
    }
    if (this.memberCountLimit < minLimit) {
      this.memberCountLimit = minLimit;
    } else if (this.memberCountLimit > maxLimit) {
      this.memberCountLimit = maxLimit;
    }
    this.memberCountLimit = Math.round(this.memberCountLimit);
  }

  submit() {

    //TODO: fast display error alert text
    // this.test.nativeElement.scrollIntoView();
    this.isFormDirty = true;
    //set chatroom_info_list as server want
    if (!this.pqr.classify_switch) {
      this.pqr.chatroom_list = this.singleChatroomData.chatroom_list.map(item => item.chatroomname);
    } else {
      this.multiChatroomData.forEach(value => {
        value.chatroomnames = value.chatroom_list.map(item => item.chatroomname);
      });
      this.pqr.chatroom_list = this.multiChatroomData;
    }

    if (this.pqr.chatroom_list.length == 0) {
      let alertObj = {
        type: "error",
        title: "请选择微信群!",
        success: {
          text: "知道了"
        }
      };
      this.myAlert.showAlert(alertObj);
      return;
    }
    //maxlength限制之后，不会超出字数
    // if(this.pqr.welcome_message.length > 500) {
    //   let alertObj = {
    //     type: "error",
    //     title: "欢迎语超出500字上限!",
    //     success: {
    //       text: "知道了"
    //     }
    //   }
    //   this.myAlert.showAlert(alertObj);
    //   return;
    // }
    // if(this.pqr.link_text.length > 140){
    //   let alertObj = {
    //     type: "error",
    //     title: "文案提示超出140字上限!",
    //     success: {
    //       text: "知道了"
    //     }
    //   };
    //   this.myAlert.showAlert(alertObj);
    //   return;
    // }
    if (this.pqr.classify_switch) {
      for (let item of this.pqr.chatroom_list) {
        if (!item.classification) {
          let alertObj = {
            type: "error",
            title: "微信群分类名称不能为空",
            success: {
              text: "知道了"
            }
          };
          this.myAlert.showAlert(alertObj);
          return;
        } else if (item.chatroomnames.length == 0) {
          let alertObj = {
            type: "error",
            title: "分类中必须选择对应的微信群",
            success: {
              text: "知道了"
            }
          };
          this.myAlert.showAlert(alertObj);
          return;
        }
      }
    }

    this.pqr.acquisition_name = this.pqr.acquisition_name || "永久入群二维码";
    this.pqr.link_title = this.pqr.link_title || "扫码入群";
    this.pqr.link_text = this.pqr.link_text || "快快扫码入群吧～";
    this.pqr.welcome_message = this.pqr.welcome_message || "您好，我是本次活动的入群小助手，若小助手未拉您入群，请回复“入群”查看进度。";

    //非vip上限100
    if (!this.clientInfo.is_vip) {
      this.pqr.member_count_limit = 100;
    } else {
      this.pqr.member_count_limit = this.memberCountLimit || 500;
    }
    if (this.pqr.custom_qrcode && this.pqr.custom_qrcode.indexOf("http") == 0) {
      this.pqr.custom_qrcode = undefined;
    }

    this.csLoader.showLoader();
    this.qrCodeService.acquisitionOperate(this.pqr).subscribe(res => {
      this.csLoader.dismissLoader();
      if (!this.pqr.acquisition_id) {
        let navLen = this.navCtrl.length();

        if (navLen <= 2) this.navCtrl.setRoot("PermanentQrHomePage");
        else this.navCtrl.remove(navLen - 2, 1);
      }
      this.util.goBack(this.navCtrl);
    }, err => {
      this.csLoader.dismissLoader();
    });
  }

  getBase64(img: File, callback: (img: any) => void) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  handleChange(info: { file: File }) {
    console.log(info);
    if (info[0].size > 10485760) {
      let alertObj = {
        type: "error",
        title: "图片上传失败",
        message: "图片过大，请上传10M以内的二维码！",
        success: {
          text: "知道了"
        }
      };
      this.myAlert.showAlert(alertObj);
      return;
    }
    this.getBase64(info[0], (img: any) => {
      this.pqr.custom_qrcode = img;
      this.pqr.custom_qrname = info[0]["name"];
    });
  }
}

const maxLimit = 500;
const minLimit = 100;



// WEBPACK FOOTER //
// ./src/pages/permanent-qr/permanent-qr-edit/permanent-qr-edit.ts